<base-sidenav
  (onClose)="close()"
  (onClear)="clear()"
  (onValidate)="validate()"
  [showValidate]="true"
  [standardForms]="standardForms"
></base-sidenav>

<ng-template #standardForms>
  <form [formGroup]="getFormGroup('standardForm')">
    <base-form-input label="Nom" [withoutPadding]="true" appearance="outline" controlName="lastName"></base-form-input>

    <base-form-input
      label="Prénom"
      [withoutPadding]="true"
      appearance="outline"
      controlName="firstName"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteContactType($event)"
      [items$]="getItems$('contactType')"
      (onScroll)="onScrollLine($event, 'contactType')"
      appearance="outline"
      controlName="contactType"
      displayProperty="label"
      label="Rôles utilisateur"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteEstablishment($event)"
      [items$]="getItems$('establishments')"
      (onScroll)="onScrollLine($event, 'establishments')"
      appearance="outline"
      controlName="establishments"
      displayProperty="label"
      label="Etablissement"
      type="search-multiple"
      [withoutPadding]="true"
    ></base-form-input>

    <base-form-input
      (autocompleteChange)="autocompleteActivity($event)"
      [items$]="getItems$('activities')"
      (onScroll)="onScrollLine($event, 'activities')"
      label="Activité"
      [withoutPadding]="true"
      appearance="outline"
      displayProperty="acronym"
      controlName="activities"
      type="search-multiple"
    ></base-form-input>
  </form>
</ng-template>
